import React from 'react'
import { Container } from '@sainsburys-tech/fable'
import { AlertCircle } from '@sainsburys-tech/icons'

import PublicDSIBHeader from '../PublicDSIBHeader'

const PasswordChangedError = () => {
  const hasQuery = window.location.search !== ''
  const search = new URLSearchParams(window.location.search)

  const retryResetPassword = () => {
    window.location.href = `${window.location.origin}/resetpassword?${search}`
  }

  const goToLogin = () => {
    window.location.href = `${window.location.origin}/signIn`
  }

  return (
    <Container as="div" className="dsib-emailVerification">
      <PublicDSIBHeader />

      <main className="dsib-emailVerification__content">
        <section className="dsib-emailVerification__panel" aria-live="polite">
          <div className="dsib-emailVerification__statusRow" role="alert">
            <AlertCircle className="dsib-emailVerification__statusIcon" aria-hidden="true" focusable="false" />
            <div className="dsib-emailVerification__statusTitle">
              Sorry, your password could not be changed at this time
            </div>
          </div>

          {hasQuery ? (
            <p className="dsib-emailVerification__helpText">
              Click
              {' '}
              <button type="button" className="dsib-emailVerification__inlineLink" onClick={retryResetPassword}>
                here
              </button>
              {' '}
              to try again.
            </p>
          ) : (
            <p className="dsib-emailVerification__helpText">
              {/* Please try again later. You can also{' '} */}
              <button type="button" className="dsib-emailVerification__inlineLink" onClick={goToLogin}>
                Try again later
              </button>
              .
            </p>
          )}
        </section>
      </main>
    </Container>
  )
}

export default PasswordChangedError
